export default "__VITE_ASSET__CWcAGicH__"